import { render } from "./ProductDetail.vue?vue&type=template&id=b0a634de"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script